import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../Translation';
import styles from './SpecialOffer.scss';

const propTypes = {
  color: PropTypes.string,
  height: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
  currencySymbol: PropTypes.string.isRequired,
};

const defaultProps = {
  color: '#27A9E1',
};

const SpecialOffer = ({ color, width, height, currencySymbol }) => (
  <div className={styles.specialOffer} style={{ width, height }}>
    <div className={styles.info}>
      <div style={{ backgroundColor: color }}>
        <Translation id="widgets.coupon.specialOffer.title" defaultMessage="Special Offer">
          {text => (
            <div className={styles.text}>{text}</div>
          )}
        </Translation>
      </div>
      <div className={styles.currencyWrap}>
        <div className={styles.currency} style={{ color }}>
          {currencySymbol}
        </div>
      </div>
    </div>
  </div>
);

SpecialOffer.propTypes = propTypes;

SpecialOffer.defaultProps = defaultProps;

export default SpecialOffer;
